import React from 'react';
import { Form } from 'antd';
import { Input, Button } from '@gamesb42/ui-kit';
import { resetPassword } from '../../../api/auth';
import appStore from '../../../store/App';
import EmailSentModal from './EmailSentModal';

interface ForgotPasswordFormProps {
  onBack: () => void;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({ onBack }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [sentEmail, setSentEmail] = React.useState('');

  const onFinish = async (values: { email: string }) => {
    setLoading(true);
    try {
      await resetPassword({ email: values.email });

      // Показываем модалку вместо notification
      setSentEmail(values.email);
      setShowSuccessModal(true);
      form.resetFields();
    } catch (error: any) {
      console.error('Reset password error:', error);
      const errorMessage =
        error?.response?.data?.detail ||
        'Failed to send password reset email. Please try again.';
      appStore.setNotification({
        type: 'error',
        title: errorMessage,
        width: 450,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleModalClose = () => {
    setShowSuccessModal(false);
    // Возвращаемся на форму логина после закрытия модалки
    onBack();
  };

  return (
    <>
      <h2
        style={{
          marginBottom: '20px',
          textAlign: 'left',
          color: '#090909',
          fontSize: '32px',
          fontWeight: 700,
          lineHeight: '40px',
          fontFamily: 'Muller',
        }}
      >
        Forgot Password
      </h2>

      <div style={{ marginBottom: '32px', color: '#606176' }}>
        Enter your E-mail
      </div>

      <Form form={form} layout="vertical" onFinish={onFinish} size="large">
        <Form.Item
          name="email"
          rules={[
            { required: true, message: 'Please input your email!' },
            { type: 'email', message: 'Please enter a valid email!' },
          ]}
        >
          <Input label="Email" placeholder="Email*" size="large" />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            size="large"
            violet
            style={{
              color: '#fff',
              width: '94px',
            }}
          >
            Submit
          </Button>
        </Form.Item>
      </Form>

      <EmailSentModal
        visible={showSuccessModal}
        email={sentEmail}
        onClose={handleModalClose}
      />
    </>
  );
};

export default ForgotPasswordForm;
